namespace $ {

	export type $shm_projects_delivery_record = {
		id: string
		preview: string
		directory: string
		delivery?: {
			type: 'hosted'
			project: string
			application: string
		}
	}

	export class $shm_projects_delivery extends $mol_object2 {

		static project< Record extends $shm_projects_delivery_record >(
			records: readonly Record[],
			project: Record,
		) {
			if( !project.delivery ) return project
			const delivery = records.find( record => record.id === project.delivery?.project )
			if( !delivery ) throw new Error( `Delivery project not found for ${ project.id }: ${ project.delivery.project }` )
			if( delivery.delivery ) throw new Error( `Nested delivery projects are not supported: ${ project.id }` )
			return delivery
		}

		static preview< Record extends $shm_projects_delivery_record >(
			records: readonly Record[],
			project: Record,
		) {
			return project.delivery?.application.trim()
				|| this.project( records, project ).preview.trim()
				|| project.preview.trim()
				|| project.directory.trim()
		}

	}

}
